import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthContext from "./AuthContext/AuthContextProvider.js";
import { PersistGate } from "redux-persist/integration/react";
import persistStore from "redux-persist/es/persistStore";
import { store } from "./ApiServices/ReduxStore/store.js";
import { Provider } from "react-redux";

const persistores = persistStore(store);

window.addEventListener("beforeunload", (event) => {
  // Check if the user is navigating away by refreshing or reloading
  sessionStorage.setItem("isReloading", "true");
});

window.addEventListener("unload", () => {
  // Check the flag from sessionStorage
  const isReloading = sessionStorage.getItem("isReloading");

  if (isReloading) {
    // If the tab is being refreshed or reloaded, do not clear data
    sessionStorage.removeItem("isReloading");
  } else {
    // If the tab or browser is being closed, clear the data
    persistores.purge(); // Clears Redux persisted state
    localStorage.clear(); // Clears all localStorage data
  }
});



const AppWrapper = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistores}>
        <AuthContext>
          <App />
        </AuthContext>
      </PersistGate>
    </Provider>
  );
};

const root = createRoot(document.getElementById("root"));

root.render(<AppWrapper />);

reportWebVitals();
